// Prompt 0455 — Hook simple para orquestar creacion/actualizacion de un rol funcional.
// No es un cache global: solo centraliza la logica I/O que consumen los tabs.

import { useCallback } from 'react';
import {
  crearRolFuncional,
  actualizarRolFuncional,
  type RolFuncional,
} from '../../../../../../shared/services/api';

export interface RolFuncionalDatosBody {
  nombre: string;
  descripcion?: string;
  nivelMinimo?: string;
  nivelMaximo?: string;
  activo?: boolean;
}

export interface UseRolFuncionalData {
  guardar: (
    rolId: string | null,
    body: RolFuncionalDatosBody,
  ) => Promise<{ rol: RolFuncional | null; createdId: string | null }>;
}

export function useRolFuncionalData(): UseRolFuncionalData {
  const guardar = useCallback(
    async (
      rolId: string | null,
      body: RolFuncionalDatosBody,
    ): Promise<{ rol: RolFuncional | null; createdId: string | null }> => {
      if (rolId) {
        await actualizarRolFuncional(rolId, body as unknown as Record<string, unknown>);
        return { rol: null, createdId: null };
      }
      const res = await crearRolFuncional({
        nombre: body.nombre,
        descripcion: body.descripcion,
        nivelMinimo: body.nivelMinimo,
        nivelMaximo: body.nivelMaximo,
      });
      return { rol: res.data, createdId: res.data.id };
    },
    [],
  );

  return { guardar };
}
